const isPC = () => {
  const userAgentInfo = navigator.userAgent
  const Agents = [
    'Android',
    'iPhone',
    'SymbianOS',
    'Windows Phone',
    'iPad',
    'iPod'
  ]
  let flag = true
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false
      break
    }
  }

  if (flag) {
    const width =
      document.documentElement.clientWidth || document.body.clientWidth
    if (width < 768) {
      //小于768px的屏幕，判定为手机
      flag = false
    }
  }
  return flag
}

/**
 * 将时间戳转换为yy-mm-dd形式
 * @param stamp
 * @param type
 * @returns {string}
 */
const formatDate = (stamp, type = 'y-m-d') => {
  const dealFormat = num => num < 10 ? `0${num}` : num
  const time = new Date(stamp)

  const y = time.getFullYear()
  const m = time.getMonth() + 1
  const d = time.getDate()

  if (type === 'y-m-d') {
    return y + '-' + dealFormat(m) + '-' + dealFormat(d)
  } else if (type === 'y-m-d-h-mm-s') {
    const h = time.getHours()
    const mm = time.getMinutes()
    const s = time.getSeconds()
    return (
      y +
      '-' +
      dealFormat(m) +
      '-' +
      dealFormat(d) +
      ' ' +
      dealFormat(h) +
      ':' +
      dealFormat(mm) +
      ':' +
      dealFormat(s)
    )
  }
}

const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
const isOpenInWebview = () => {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') { // 微信浏览器判断
    return false
  } else if (ua.match(/QQ/i) == 'qq') { // QQ浏览器判断
    return false
  } else if (ua.match(/WeiBo/i) == 'weibo') {
    return false
  }
  if (ua.match(/Android/i) !== null) {
    return ua.match(/chrome/i) === null
  } else if (ua.match(/iPhone/i) !== null) {
    return ua.match(/safari/i) === null
  }
  return ua.match(/macintosh/i) === null && ua.match(/windows/i) === null


}


export {
  formatDate,
  getParameterByName,
  isOpenInWebview,
  isPC}
